import { useQuery } from '@tanstack/react-query';
import useInfrastructure from '../../useInfrastructure';
import { useNetwork } from '@nftx/react';
import { QueryKey } from '../../queryKeys';

const usePremiumPaids = ({ vaultId }: { vaultId?: string } = {}) => {
  const {
    auctions: { fetchPremiumPaids },
  } = useInfrastructure();
  const network = useNetwork();

  return useQuery(
    [QueryKey.PREMIUM_PAIDS, network, vaultId],
    () => {
      return fetchPremiumPaids({ network, vaultId });
    },
    { staleTime: 3600000, refetchInterval: 3600000 }
  );
};

export default usePremiumPaids;
